import styles from './styles.module.scss';
import React, {useContext} from 'react';
import {OnboardingContext, OnboardingContextType} from '../../../Onboarding/context';
import {FormikContextType, useFormikContext} from 'formik';
import {StepPosition} from '../../../../types/form';
import {isEmpty} from 'lodash';
import Button from '../../../button';
import classnames from 'classnames';

export interface Props<FormValues> {
  stepPosition: StepPosition;
  onControlledSubmit: (
    form: FormikContextType<FormValues>,
    stepPosition: StepPosition
  ) => Promise<void>;
}

export default function MobileOnboardingProgressButton<FormValues>(props: Props<FormValues>) {
  const {canSubmit, primaryButton, isControlledStep} =
    useContext<OnboardingContextType>(OnboardingContext);
  const form = useFormikContext<FormValues>();
  const onControlledSubmit = (): void => {
    props.onControlledSubmit(form, props.stepPosition);
  };

  let text = primaryButton.text;

  if (canSubmit && primaryButton.color !== 'red') {
    text = 'Complete Onboarding';
  } else if (text === 'Next') {
    text = 'Continue';
  }

  const primaryDisabled = primaryButton.controlled
    ? primaryButton.disabled
    : form.isSubmitting || !isEmpty(form.errors);

  return (
    <div className={classnames(styles.center)}>
      <Button
        testId="mobile-onboarding-progress-button"
        disabled={primaryDisabled}
        type={isControlledStep ? 'button' : 'submit'}
        color={primaryButton.color || 'primary'}
        onClick={isControlledStep ? onControlledSubmit : undefined}
        width={250}
      >
        {text}
      </Button>
    </div>
  );
}
